export const templateKeys = {
    all: (scenarioId: string) => ['templates', scenarioId] as const
} as const;
